import { render, staticRenderFns } from "./ProjectInternalOrders.vue?vue&type=template&id=0ea88ff7&scoped=true"
import script from "./ProjectInternalOrders.vue?vue&type=script&lang=ts"
export * from "./ProjectInternalOrders.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInternalOrders.vue?vue&type=style&index=0&id=0ea88ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea88ff7",
  null
  
)

export default component.exports